<template>
  <div>
    <div class="info-box">
      <div class="title-box">
        <p>活动信息</p>
        <el-button
          type="danger"
          icon="el-icon-edit"
          @click="$router.push({name:'centerActivityInfo'})"
        >发起活动</el-button>
      </div>
      <div class="info-content" style="padding-bottom:0">
        <el-row :gutter="16" style="width:100%">
          <el-col :span="24">
            <el-card class="box-card">
              <el-input placeholder="活动名称" v-model="search.name" clearable style="width: 200px"></el-input>
              <el-date-picker
                v-model="search.startdate"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>

              <el-select
                v-model="search.audit_status"
                placeholder="审核状态"
                clearable
                style="width: 200px"
              >
                <el-option :value="1" label="未审核"></el-option>
                <el-option :value="2" label="审核通过"></el-option>
                <el-option :value="3" label="审核不通过"></el-option>
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="$refs.activityRef.handleSearch()"
              >搜索</el-button>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="info-content">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <WtDataList
                  v-model="data.list"
                  :url="$url.activity.user"
                  :pageSize="6"
                  :search="search"
                  ref="activityRef"
                >
                  <div slot="list" style="padding:0 0 20px 0;">
                    <div class="activity-box">
                      <div class="activity-bottom">
                        <el-row :gutter="16">
                          <el-col
                            :span="8"
                            v-for="(item,index) in data.list"
                            :key="index"
                            style="margin:10px 0;"
                          >
                            <el-card :body-style="{ padding: '0px',width:'100%' }">
                              <div slot="header" class="clearfix">
                                <template v-if="item.audit_status == 1">
                                  <div class="status coming">{{item.audit_status_text}}</div>
                                </template>
                                <template v-else-if="item.audit_status == 3">
                                  <div class="status end">{{item.audit_status_text}}</div>
                                </template>
                                <template v-else-if="item.audit_status == 2 ">
                                  <template v-if="item.activity_status == 1">
                                    <div class="status coming">活动即将开始</div>
                                  </template>
                                  <template v-else-if="item.activity_status == 3">
                                    <div class="status end">活动已结束</div>
                                  </template>
                                  <template v-else-if="item.activity_status == 2 ">
                                    <div class="status ing">活动进行中</div>
                                  </template>
                                </template>
                              </div>
                              <router-link :to="{ name: 'activityInfo',query: { id: item.id }}">
                                <img :src="item.cover_photo_text[0].path" class="image" />
                              </router-link>
                              <div style="padding: 14px;">
                                <span>{{item.name}}</span>
                                <div class="bottom clearfix">
                                  <time
                                    class="time"
                                  >{{item.province_text}}{{item.city_text}}{{item.country_text}}</time>
                                  <el-button
                                    type="text"
                                    class="button"
                                  >{{getDate(item.activity_start)}}月{{getDate(item.activity_start,'D')}}日</el-button>
                                </div>
                                <div style="margin-top:10px;">
                                  <el-button
                                    type="primary"
                                    icon="el-icon-edit"
                                    circle
                                    @click="$router.push({name:'centerActivityInfo',query:{'id':item.id}})"
                                  ></el-button>

                                  <el-button
                                    type="danger"
                                    icon="el-icon-delete"
                                    circle
                                    @click="deleteActivity(item.id)"
                                  ></el-button>
                                </div>
                              </div>
                            </el-card>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </WtDataList>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>
    <el-dialog title="反哺大学生登记审核" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="审核结果：">
          <el-radio-group v-model="form.resource">
            <el-radio label="审核通过"></el-radio>
            <el-radio label="驳回修改（允许编辑后重新登记）"></el-radio>
            <el-radio label="审核拒绝（不允许再进行登记）"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" v-model="form.desc" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(),
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      value2: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      radio: 3,
      dialogVisible: false,
      data: {},
      search: {},

      navStatus: 1
    };
  },
  methods: {
    toogleExpand(row) {
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row, false);
    },
    handleEdit(data) {
      console.log(data);
      this.dialogVisible = true;
    },
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },

    deleteActivity(id) {
      let self = this;
      this.$confirm("此操作将永久删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: function(action) {
          if (action != "cancel") {
            self.$db.delete(self.$url.activity.url + "/" + id).then(resp => {
              self.$notify({
                title: "成功",
                message: "活动已成功删除",
                type: "success"
              });
              self.$refs.activityRef.handleSearch();
            });
          }
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.profile-position {
  padding: 5px 0;
  color: #515a6e;
}
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;
    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#app-activity {
  width: 100%;
  // margin-bottom: 45px;
  background-color: #f5f5f5;
}




.status {
  float: right;
  padding: 3px 0;
}
.status.ing {
  color: rgba(255, 111, 2, 0.8);
}
.status.end {
  color: #999;
}
.status.coming {
  color: #f8b92b;
}


.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
  font-size: 20px;
}

.image {
  max-width: 100%;
  height: 282px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/view/Center/activity/list.vue